import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "o-searchMap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_map = _resolveComponent("m-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_m_map, {
      class: "o-searchMap__map",
      brokers: _ctx.brokers,
      hovered: _ctx.activeBroker,
      "is-loading": _ctx.isLoading,
      "fit-brokers": !!_ctx.query,
      "max-bounds": $data.maxBounds,
      message: !$data.isDesktop && !_ctx.isLoading ? $props.texts.noResults : '',
      "scroll-zoom": true,
      texts: $props.texts,
      type: "broker",
      onHover: _ctx.setActiveBroker,
      onMove: $options.onMove
    }, null, 8 /* PROPS */, ["brokers", "hovered", "is-loading", "fit-brokers", "max-bounds", "message", "texts", "onHover", "onMove"])
  ]))
}